import { UI } from '../UI';
import { MasterProductData } from '../MasterProductData';
import html2canvas from '../html2canvas';

import './scss/style.scss';

export const MockupCompare = (function () {
  const mapping = {
    data: (data) => {
      let compares = [];
      data.forEach((area) => {
        if (!area.isHidden) {
          area.areaDetails.forEach((item) => {
            if (!item.isHidden && item.fileType == 1 && item.imageFileUrl && item.file === null) {
              let exist = _.findWhere(compares, { color: item.color, areaType: item.areaType });
              if (!exist) {
                let toCompare = _.where(area.areaDetails, { color: item.color, isHidden: false, fileType: 1 });
                let arrCompare = [];
                toCompare.forEach((j) => {
                  if (j.file !== null) {
                    arrCompare.push(j);
                  }
                });
                if (arrCompare.length) {
                  let { areaType, areaTypeDisplayName } = area;
                  compares.push({
                    areaType,
                    areaTypeDisplayName,
                    color: item.color,
                    //items: [$.extend(true, {}, item), $.extend(true, {}, arrCompare[0])]
                    images: [
                      item.imageFileUrl,
                      arrCompare[0].imageFileUrl ? arrCompare[0].imageFileUrl : arrCompare[0].fileSrc
                    ]
                  });
                }
              }
            }
          });
        }
      });
      return {
        compareDialog: compareDialog,
        customizeLink: customizeLink,
        data: compares
      };
    },
    dataStudio: (data) => {
      return {
        compareDialog: compareDialogStudio,
        compareFile: data || {}
      };
    }
  };

  const compareDialog = (image1, image2, studio = false) => {
    let template = require('./tmpl/dialog.hbs');
    bootbox.dialog({
      message: template({ image1, image2, studio }),
      size: 'extra-large',
      className: 'mockup-filecompare-modal-dialog'
    });
  };

  const customizeLink = (id, color = null, side = null) => {
    const pColor = color ? `&color=${$.trim(color)}` : ``;
    const pSide = side ? `&side=${$.trim(side)}` : ``;
    MasterProductData.productFormSubmit(null, () => {
      $router.push(
        `/prelistings/${id}/design-studio?ref=${document.location.pathname + document.location.search}${pColor}${pSide}`
      );
    });
  };

  const compareDialogStudio = (img) => {
    UI.blockPage();
    let node = document.getElementById('blankWrap');
    $(window).scrollTop(0);
    html2canvas(node, {
      useCORS: true,
      onclone: (el) => {
        $('#rotate, #remove, .ui-resizable-handle', $(el)).remove();
      }
    }).then((canvas) => {
      UI.unblockPage();
      compareDialog(img, canvas.toDataURL('image/png'), true);
    });
  };

  return {
    mapping,
    compareDialog,
    compareDialogStudio
  };
})();
